import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { UserInfo } from "./types/UserInfo";

// This file is the entry point for the application in stand alone mode.
// It is not used in the MFE mode.
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App
      MixPanel={{ track: () => {} }}
      language="en"
      userInfo={{} as UserInfo}
      tokenId="test-token-id"
    />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
